<template>
  <div class="sidebar-details-options">
    <div
      class="sidebar-details-options-item pdf"
      v-tooltip.auto="$t('tooltip.savePDF')"
      @click="$emit('pdf')"
      v-if="!disablePdf"
    >
      <img src="img/pdf_icon.svg" />
    </div>
    <div
      class="sidebar-details-options-item qrcode"
      v-tooltip.auto="$t('tooltip.qrcode')"
      @click="$modal.show('qrcode-modal')"
    >
      <img src="img/qr_code_icon.svg" />
    </div>
    <a v-bind:href="panoramaUrl" target="_blank">
      <div class="sidebar-details-options-item degrees" v-tooltip.auto="$t('tooltip.view')">
        <img src="img/360_degrees_icon.svg" />
      </div>
    </a>
    <div
      class="sidebar-details-options-item calc"
      v-tooltip.auto="$t('tooltip.calculator')"
      @click="$emit('calc')"
    >
      <img src="img/calculator_icon.svg" />
    </div>
    <a
      v-if="coordinates"
      class="sidebar-details-options-item navigation"
      v-tooltip.auto="$t('tooltip.navigation')"
      :href="`https://www.google.com/maps/dir/?api=1&destination=${coordinates[1]},${coordinates[0]}`"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src="img/navigation_icon.svg" />
    </a>
  </div>
</template>

<script>
export default {
  props: {
    panoramaUrl: String,
    coordinates: {
      type: Array,
      default: undefined
    },
    disablePdf: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    qrcode() {
      console.log("$modal.show('qrcode-modal')");
      this.$modal.show('qrcode-modal');
    }
  }
};
</script>